import { i18n } from "@/locales/setup.js"
const locale = i18n.messages[i18n.locale]

export default () => ({
	listing: {
		searchTerm: null,

		filter: {
			payload: null,
			where: { type_in: "CUSTOMER" },
			isFiltering: false
		},

		tab: "individual",

		header: [],

		sorting: {
			fieldName: "createdAt",
			type: "desc"
		},

		page: 1
	}
})
